import AdGroupList from 'common/pages/ad-group/AdGroupList'

export const AdGroupListAgency = (props) =>
    <AdGroupList {...props} mode={props.mode} agency />